import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ParametresModel} from '../../../_models/CapaModels/Parametres.model';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {AuthenticationService} from '../../../_services/authentication.service';
import {Router} from '@angular/router';
import {ApiCapaService} from '../../../_services/apiCapa.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InstallModel} from '../../../_models/CapaModels/install.model';
import {RelInstallParametreModel} from '../../../_models/CapaModels/RelInstallParametre.model';
import {AccountModel} from '../../../_models/CapaModels/Account.model';
import {delay} from 'q';

@Component({
  selector: 'app-license-sidebar',
  templateUrl: './license-sidebar.component.html',
  styleUrls: ['./license-sidebar.component.css']
})
export class LicenseSidebarComponent implements OnInit {

    @Input() account: AccountModel;
    @Input() install: InstallModel;

    @Output() refreshEvent = new EventEmitter();
    @Output() userRefreshEvent = new EventEmitter();

    page: any = this.router.url.split('/')[3];
    idInstall: string = this.router.url.split('/')[4];

    success: boolean = false;

    installInfoForm: FormGroup;

    public _allParameters: ParametresModel[] = [];
    public allParametersCopy: ParametresModel[] = [];
    paramsOpen: boolean = true;

    constructor(private oauthService: OAuthService, private cdRef: ChangeDetectorRef, private authenticationService: AuthenticationService,
              private router: Router, private ApiClient: ApiCapaService, private formBuilder: FormBuilder) {
    }

    get allParameters() {
        return this._allParameters;
    }

    set allParameters(val: ParametresModel[]) {
        this._allParameters = val;
    }

    ngOnInit() {
        this.createForms();

        if (this.page === 'list') {
            this.ApiClient.post('Parametres/filtered-list', {}).subscribe(Parameters => {
              this.allParameters = Parameters.entities;
              this.allParametersCopy = Parameters.entities;
            });
        } else {
            // TODO : Remplacer par filtered-list
            this.ApiClient.get('Parametres/parameters-for-install/' + this.idInstall).subscribe(Parameters => {
                this.allParameters = Parameters;
                this.allParametersCopy = Parameters;
            });
        }
    }

    switchParametersBox() {
        this.paramsOpen = !this.paramsOpen;
    }

    createForms() {
        const licenseName = new FormControl('', Validators.required);
        const clientNumber = new FormControl('', Validators.required);

        this.installInfoForm = this.formBuilder.group({
            idInstall: [''],
            licenseName: ['', Validators.required],
            clientNumber: ['', Validators.required]
        });
    }

    updateList(id: number, property: string, event: any) {
        this.allParametersCopy[id][property] = event.target.textContent;
    }

    onUpdateInstallParameters(value) {
        this.install.nom = value.licenseName.toUpperCase();
        this.install.numeroClient = value.clientNumber.toUpperCase();

        const relInstallParamArray: any[] = [];
        this.allParametersCopy.forEach(parameter => {
            const rel_install_param: any = new RelInstallParametreModel(
                parameter.IDRelInstallParametre,
                parameter.idParametre,
                parameter.valeurParam,
                this.idInstall
            );
            relInstallParamArray.push(rel_install_param);
        });

        this.ApiClient.post('Installs/upsert', this.install).subscribe();

        this.ApiClient.post('RelInstallParametres/bulk-upsert', relInstallParamArray).subscribe( Response => {
            this.success = true;
        });
    }

    onSubmitInstallInfoForm(value) {
        const install = new InstallModel();

        install.nom = value.licenseName.toUpperCase();
        install.nbBasesAutorisees = 1;
        install.nbJourUtilisation = 0;
        install.nbCredits = 0;
        install.numeroClient = value.clientNumber.toUpperCase();
        if (this.account != null) {
            install.idAccount = this.account.idAccount;
        }

        const relInstallParamArray: any[] = [];

        this.ApiClient.post('Installs/upsert', install).subscribe(Response => {

            install.idInstall = Response;
            this.allParametersCopy.forEach(parameter => {

                const rel_install_param: any = new RelInstallParametreModel(
                    0,
                  parameter.idParametre,
                  parameter.valeurParam,
                  install.idInstall
                );
                relInstallParamArray.push(rel_install_param);
            });

            this.ApiClient.post('RelInstallParametres/bulk-upsert', relInstallParamArray).subscribe(res => {
                this.success = true;
                this.allParametersCopy = this.allParameters;
                value.licenseName = '';
                value.clientNumber = '';
                if (this.account != null) {
                    this.userRefreshEvent.emit({event: event, install: install});
                } else {
                    this.refreshEvent.next();
                }
            });
        });
    }
}
